import intToReal from '@helpers/intToReal';
import LotteriesEnum from '@data/lotteries';

class Lottery {
  constructor (data, isSpecial = false) {
    data = data || {}

    this.id = parseInt(data.lotteryID, 10) || null
    this.name = data.lotteryName || null
    this.shortname = null
    this.acron = null
    this.slug = null
    this.isSpecial = isSpecial
    this.numbers = data.numbers || 0
    this.minBet = data.minBet || 0
    this.maxBet = data.maxBet || 0
    this.minBetClover = data.minClovers || 0
    this.maxBetClover = data.maxClovers || 0
    this.minNumClover = data.minClover || 0
    this.maxNumClover = data.maxClover || 0
    this.maxDuration = data.maxDuration || 1
    this.description = data.description || null
    this.descriptionStriped = null
    this.results = data.results || null
    this.keyValues = data.keyValues || []
    this.prices = data.prices || []
    this.minNumber = data.minNumber || 0
    this.maxNumber = data.maxNumber || 0
    this.extra = {}
    this.color = null
    this.hasCustomGame = false
    this.hasBolaoGame = false
    this.hasDuration = false
    this.gameType = 'tens'
    this.durations = data.durations || []
    this.closures = data.closures || null
    this.showInFront = true
    this.drawDays = null
    this.drawTime = null
    this.prizeTrack = []
    this.canDesdobramentos = false
    this.canFechamentos = false

    let lotteryExtraInfo = null

    lotteryExtraInfo = LotteriesEnum.find((a) => {
      return a.id === this.id && a.special === this.isSpecial
    })

    if (!lotteryExtraInfo) {
      lotteryExtraInfo = LotteriesEnum.find((a) => {
        return a.id === this.id
      })
    }

    if (lotteryExtraInfo.name !== this.name) {
      this.name = lotteryExtraInfo.name
    }

    this.acron = lotteryExtraInfo.acron || null
    this.slug = lotteryExtraInfo.slug || null
    this.shortname = lotteryExtraInfo.shortname || null
    this.color = lotteryExtraInfo.color || null

    this.description = lotteryExtraInfo.description
      ? lotteryExtraInfo.description
      : this.description

    this.descriptionStriped = (this.description || '').replace(
      /(<([^>]+)>)/gi,
      ''
    )

    this.results = lotteryExtraInfo.results
      ? lotteryExtraInfo.results
      : this.results
    this.hasCustomGame = lotteryExtraInfo.hasCustomGame
    this.hasBolaoGame = lotteryExtraInfo.hasBolaoGame
    this.gameType = lotteryExtraInfo.gameType
    this.hasDuration = lotteryExtraInfo.hasDuration
    this.maxNormalDuration = this.maxDuration || lotteryExtraInfo.maxNormalDuration
    this.showInFront = lotteryExtraInfo.showInFront
    this.hasKey = lotteryExtraInfo.hasKey
    this.keyName = lotteryExtraInfo.keyName || null
    this.drawDays = lotteryExtraInfo.drawDays || null
    this.drawTime = lotteryExtraInfo.drawTime || null
    this.prizeTrack = lotteryExtraInfo.prizeTrack || []
    this.canDesdobramentos = lotteryExtraInfo.canDesdobramentos || false
    this.canFechamentos = lotteryExtraInfo.canFechamentos || false

    if (this.prices && Array.isArray(this.prices)) {
      this.prices.map((a) => {
        a.sellPriceText = intToReal(a.sellPrice)
        return a
      })
    }
  }
}

export default Lottery;
